import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import aboutImage from '../../assets/images/1.png';
import historyImage from '../../assets/images/2.png';
import '../../components/AboutBanner/AboutBanner.css';
import '../../styles/CustomClassCss/Custom.css';

const AboutBanner = () => {
  const [buyers, setBuyers] = useState(0);
  const [sellers, setSellers] = useState(0);
  const [enquiries, setEnquiries] = useState(0);
  const [quotations, setQuotations] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (buyers < 1475) setBuyers(prev => prev + 1);
      if (sellers < 2000) setSellers(prev => prev + 1);
      if (enquiries < 60) setEnquiries(prev => prev + 1);
      if (quotations < 40) setQuotations(prev => prev + 1);
    }, 10);

    return () => clearInterval(interval);
  }, [buyers, sellers, enquiries, quotations]);

  const contentVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  const imageVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" },
    },
  };

  return (
    <>
      <div className="about-page custom-container-upper">
        <div className="container">
          <div className="about-grid custom-inner-space">
            <motion.div
              className="about-content"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={contentVariant}
            >
              <div className="about-tops font-merriweather ">
                <span className="about-text-about">ABOUT</span>&nbsp;
                <span className="stelmart-text-about">STELMART</span>
              </div>
              <h2 className='font-merriweather custom-top-space'>
                Revolutionizing Steel And Polymer Trade
              </h2>
              <p className='font-poppins custom-top-space'>
                StelMart is a digital platform that connects buyers, sellers, and financial institutions revolutionizing the steel market.              
              </p>
            </motion.div>
            <motion.div
              className="about-image"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={imageVariant}
            >
              <img src={aboutImage} alt="About Stalmart" />
            </motion.div>
          </div>
        </div>
      </div>

      <div className="stats-section-about custom-inner-space custom-container-upper font-poppins">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="stats-heading-about"
        >
          Stelmart is more than just a marketplace—it’s a revolutionary digital ecosystem that sets a new benchmark for efficiency, trust, and growth in the steel and polymer industry.
        </motion.h2>
        <div className="stats-container-about">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="stats-box-about"
          >
            <div className="count-container font-poppins">
              <div className="count">{buyers}+</div>
              <div className="business-text">Verified Buyers</div>
            </div>
            <div className="divider-about"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="stats-box-about"
          >
            <div className="count-container font-poppins">
              <div className="count">{sellers}+</div>
              <div className="business-text">Verified Sellers</div>
            </div>
            <div className="divider-about"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            className="stats-box-about"
          >
            <div className="count-container font-poppins">
              <div className="count">{enquiries}+</div>
              <div className="business-text">Enquiries Received</div>
            </div>
            <div className="divider-about"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="stats-box-about"
          >
            <div className="count-container font-poppins">
              <div className="count">{quotations}+</div>
              <div className="business-text">Quotations Submitted</div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="history-section ">
        <div className="history-grid custom-inner-space custom-container-upper">
          <div className="history-image">
            <img src={historyImage} alt="History" />
          </div>
          <div className="history-content">
            <h3 className="font-merriweather">Brief History</h3>
            <p className="font-poppins">
              The steel and polymer industries have long been the backbone of modern economies, powering infrastructure, technology, and consumer goods.
           </p>
           <p className="font-poppins">
           From the construction of skyscrapers and bridges to the creation of everyday items, the demand for these materials has grown exponentially over the years.
            </p>
            <p className="font-poppins">
            Yet, despite their significance, these industries continue to face complex challenges—from market fragmentation to inefficient transaction processes. </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutBanner;
